import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  HOUSEHOLD_APPLICATION_ARCHIVED_REASON_TO_LABEL_MAPPING,
  HOUSEHOLD_REJECTED_REASON_OPTION_ITEMS,
} from 'common/householdConstants';
import { USER_ROLE_ADMIN } from 'common/userRoles';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

import './SrArchivedHouseholdCard.less';

const SrArchivedHouseholdCard = ({ household, currentUser }) => {
  const { householdListing, leadRenterId, id } = household;

  const cancelReason = household.cancelReason || householdListing.cancelReason;
  const archivedDate = household.archivedDate || householdListing.archivedDate;
  const rejectedReason = household.rejectedReason || householdListing.rejectedReason;

  let message;
  if (cancelReason) {
    message = HOUSEHOLD_APPLICATION_ARCHIVED_REASON_TO_LABEL_MAPPING[cancelReason];
  }

  if (rejectedReason) {
    message =
      'Denied: ' +
      (HOUSEHOLD_REJECTED_REASON_OPTION_ITEMS.find(({ value }) => value === rejectedReason)
        ?.label || rejectedReason);
  }
  const archivedDateFormatted = archivedDate
    ? moment(archivedDate).calendar(null, {
        sameDay: '[today]',
        lastDay: '[yesterday]',
        lastWeek: 'MMM Do',
        sameElse: 'MMM Do',
      })
    : 'recently';

  const title = (
    <SrText font="greycliff" weight="bolder" size="larger">
      Application #{id}
    </SrText>
  );

  return (
    <div styleName="component">
      <div styleName="header">
        <div styleName="navIcon" />
        <div>
          {currentUser.roles.includes(USER_ROLE_ADMIN) ? (
            <SrLink to={`/admin/household/all/${leadRenterId}`} target="_black">
              {title}
            </SrLink>
          ) : (
            title
          )}
          <br />
          <SrText font="greycliff" weight="bold" size="medium" color="grey600">
            Archived {archivedDateFormatted}
          </SrText>
        </div>
      </div>
      <SrBox marginTop="20px" />
      <SrText font="greycliff" weight="bolder">
        Reason
      </SrText>
      <SrBox marginTop="10px" />
      <SrText font="greycliff" weight="bold">
        {message}
      </SrText>
    </div>
  );
};

SrArchivedHouseholdCard.propTypes = {
  household: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
};

SrArchivedHouseholdCard.displayName = 'SrArchivedHouseholdCard';

export default SrArchivedHouseholdCard;
